module.exports = __webpack_public_path__ + "static/media/20180608_161803.8add5f2d.jpg";